var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 310,
    viewBox: "0 0 311 310",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M310.037 155C310.037 240.604 240.642 310 155.037 310C69.4333 310 0.0374756 240.604 0.0374756 155C0.0374756 69.3959 69.4333 0 155.037 0C240.642 0 310.037 69.3959 310.037 155Z",
    fill: "#1B1C3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.037 26L174.172 96.1106L230.862 50.6368L205.132 118.604L277.724 115.137L216.957 155L277.724 194.863L205.132 191.396L230.862 259.363L174.172 213.889L155.037 284L135.903 213.889L79.2132 259.363L104.943 191.396L32.3512 194.863L93.1175 155L32.3512 115.137L104.943 118.604L79.2132 50.6368L135.903 96.1106L155.037 26Z",
    fill: "#EF50A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155.037 26L174.172 96.1106L230.862 50.6368L205.132 118.604L277.724 115.137L216.957 155L277.724 194.863L205.132 191.396L230.862 259.363L174.172 213.889L155.037 284L135.903 213.889L79.2132 259.363L104.943 191.396L32.3512 194.863L93.1175 155L32.3512 115.137L104.943 118.604L79.2132 50.6368L135.903 96.1106L155.037 26Z",
    fill: "#EF50A2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0375 93L122.037 82.5L163.537 103L179.037 87.5L205.037 82.5L233.537 126L231.537 144.5L216.537 152.5V200.5L183.537 226L122.037 223L89.0375 193L94.0375 152.5L78.5375 141L89.0375 93Z",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M185.611 170.864V174.883M147.425 188.952H159.484L153.455 194.981L147.425 188.952Z",
    stroke: "#5E5F71",
    strokeWidth: 16.0783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5157 148.73C90.2699 157.419 89.1354 166.358 89.1393 175.332C89.1393 208.871 117.936 227.136 153.453 227.136C188.97 227.136 217.766 208.871 217.766 175.332C217.726 166.321 216.391 157.362 213.802 148.73M121.296 170.862V174.882",
    stroke: "#5E5F71",
    strokeWidth: 16.0783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125.327 126.647C122.24 135.088 116.621 142.95 106.483 146.745C90.9597 152.549 77.7353 144.357 77.0922 138.706C76.1837 130.715 86.5542 86.2099 109.249 82.4315C124.708 79.851 138.6 89.2246 138.6 100.399C148.768 97.8178 159.433 97.9342 169.542 100.737C169.542 89.5623 184.367 79.851 199.826 82.4315C222.52 86.2099 232.891 130.715 231.983 138.706C231.339 144.357 218.115 152.549 202.591 146.745C192.454 142.95 187.679 135.088 184.592 126.647",
    stroke: "#5E5F71",
    strokeWidth: 16.0783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar4);
export default __webpack_public_path__ + "static/media/avatar4.a16cdf61d04ac2f2f0f084d314c563ee.svg";
export { ForwardRef as ReactComponent };